export const consultclearchoice = {
	PAGE_THEME_ENABLED: false,
};
